import { NetworkType } from '@amarantos/api-client'
import { z } from 'zod/v3'

const baseNetworksSearchSchema = z.object({
	/** The network the edit (rename / type) dialog targets. */
	networkId: z.coerce.number().int().positive().optional(),
	/** Narrows the list to one network type; absent shows every type. */
	type: z.nativeEnum(NetworkType).optional(),
})

// Create/edit dialog state. The edit dialog targets the selected `networkId`, so the
// `edit` branch needs no id of its own.
const dialogSearchStateSchema = z.union([
	z.object({ dialog: z.literal('create') }),
	z.object({ dialog: z.literal('edit') }),
	z.object({ dialog: z.undefined().optional() }),
])

export const networksSearchSchema = baseNetworksSearchSchema.and(dialogSearchStateSchema)

export type NetworksSearch = z.infer<typeof networksSearchSchema>
